// import { ntxAPI } from '@API/axiosNeatex';
// import { Card, CardBody, CardFooter } from '@components/card/card';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
// import type { APIResponse } from '@store/Shared/shared';
// import { TreeSelect } from 'antd';
// import React, { useState } from 'react';
// import { Table, Spinner, Form, Row, Col, Button, Alert, CardHeader, Collapse } from 'react-bootstrap';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { ChevronDown, ChevronUp } from 'lucide-react';

// // Define types for our data
// interface Payment {
//   invoiceNumber: string;
//   codE_PAYMENTS: string;
//   paymenT_DATE: string;
//   amounT_PAYMENTS: number;
// }

// interface SupplierPayment {
//   supplierId: string;
//   supplierName: string;
//   supplierName2: string | null;
//   paymentMethod: string;
//   totalPayments: number;
//   payments: Payment[];
// }
// const SupplierPaymentsReport: React.FC = () => {
//   const { treeSuppliersData } = useGetSuppliersList();
//   const [data, setData] = useState<SupplierPayment[]>([]);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);
//   const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});

//   // Filter states
//   const [selectedSupplier, setSelectedSupplier] = useState<string>('');
//   const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
//   const [startDate, endDate] = dateRange;

//   // Function to fetch data with filters
//   const fetchData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       // Prepare query parameters

//       // API call with filters
//       const { data } = await ntxAPI.get<APIResponse<SupplierPayment[]>>('Reports/GetSupplierPaymentsReport', {
//         params: { SupplierId: selectedSupplier, StartDate: startDate, EndDate: endDate }
//       });
//       if (data.succeeded === true) {
//         setData(data.data);
//       } else {
//         setError(data instanceof Error ? data.message : 'An unknown error occurred');
//       }

//       //   setData(response.data.data);
//     } catch (err) {
//       setError(err instanceof Error ? err.message : 'An unknown error occurred');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const resetFilters = () => {
//     setSelectedSupplier('all');
//     setDateRange([null, null]);
//   };

//   const formatCurrency = (amount: number): string => {
//     return new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: 'USD'
//     }).format(amount);
//   };

//   const formatDate = (dateString: string): string => {
//     return new Date(dateString).toLocaleDateString();
//   };

//   // Toggle row expansion
//   const toggleRow = (supplierId: string) => {
//     setExpandedRows(prev => ({
//       ...prev,
//       [supplierId]: !prev[supplierId]
//     }));
//   };

//   return (
//     <div className='container mt-4'>
//       <Card>
//         <CardHeader className='d-flex justify-content-between align-items-center'>
//           <h5 className='mb-0'>Invoice Reconciliation Report</h5>
//           {data.length > 0 && (
//             <div>
//               <span className='me-2'>Total: {data.length} invoices</span>
//             </div>
//           )}
//         </CardHeader>

//         <CardBody>
//           {error && (
//             <Alert variant='danger' className='mb-4'>
//               Error loading data: {error}
//             </Alert>
//           )}

//           {/* Filters Section */}
//           <Card className='mb-4'>
//             <CardHeader>Filters</CardHeader>
//             <CardBody>
//               <Form>
//                 <Row className='g-3'>
//                   <Col md={4}>
//                     <Form.Group controlId='supplierFilter'>
//                       <Form.Label>Supplier</Form.Label>

//                       <TreeSelect
//                         showSearch
//                         className='w-100'
//                         treeLine
//                         // placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                         allowClear
//                         treeDefaultExpandAll={false} // لا تقم بتوسيع كل العقد افتراضيًا
//                         value={selectedSupplier}
//                         onChange={(option: any) => {
//                           setSelectedSupplier(option === null ? null : option);
//                         }}
//                         // loading={loading5}
//                         treeData={treeSuppliersData}
//                         treeNodeFilterProp='title'
//                       />
//                     </Form.Group>
//                   </Col>

//                   <Col md={4}>
//                     <Form.Group controlId='dateRangeFilter'>
//                       <Form.Label>Date Range</Form.Label>
//                       <DatePicker
//                         allowSameDay
//                         selectsRange={true}
//                         startDate={startDate}
//                         endDate={endDate}
//                         onChange={update => setDateRange(update)}
//                         // isClearable={true}
//                         className='form-control text-center'
//                         placeholderText='Select date range'
//                       />
//                     </Form.Group>
//                   </Col>

//                   <Col xs={12} className='text-end'>
//                     <Button variant='secondary' onClick={resetFilters} className='me-2'>
//                       Reset Filters
//                     </Button>
//                     <Button variant='primary' onClick={fetchData} disabled={loading}>
//                       {loading ? (
//                         <>
//                           <Spinner
//                             as='span'
//                             animation='border'
//                             size='sm'
//                             role='status'
//                             aria-hidden='true'
//                             className='me-2'
//                           />
//                           Loading...
//                         </>
//                       ) : (
//                         'Load Data'
//                       )}
//                     </Button>
//                   </Col>
//                 </Row>
//               </Form>
//             </CardBody>
//           </Card>

//           {/* Results Section */}
//           {loading ? (
//             <div className='text-center my-5'>
//               <Spinner animation='border' role='status'>
//                 <span className='visually-hidden'>Loading...</span>
//               </Spinner>
//               <p className='mt-2'>Loading payment data...</p>
//             </div>
//           ) : data.length > 0 ? (
//             <div className='table-responsive'>
//               <Table striped bordered hover className='mb-0'>
//                 <thead>
//                   <tr>
//                     <th style={{ width: '30px' }}></th>
//                     <th>Supplier</th>
//                     <th>Payment Method</th>
//                     <th>Total Payments</th>
//                     <th>Payment Count</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {data.map(supplier => (
//                     <React.Fragment key={supplier.supplierId}>
//                       <tr
//                         onClick={() => toggleRow(supplier.supplierId)}
//                         style={{ cursor: 'pointer' }}
//                         // className='table-row-expandable'
//                       >
//                         <td>{expandedRows[supplier.supplierId] ? <ChevronUp /> : <ChevronDown />}</td>
//                         <td>
//                           <div>{supplier.supplierName}</div>
//                           {supplier.supplierName2 && <div className='text-muted small'>{supplier.supplierName2}</div>}
//                         </td>
//                         <td>{supplier.paymentMethod}</td>
//                         <td>{formatCurrency(supplier.totalPayments)}</td>
//                         <td>{supplier.payments.length}</td>
//                       </tr>
//                       <tr>
//                         <td colSpan={5} className='p-0 border-top-0'>
//                           <Collapse in={expandedRows[supplier.supplierId]}>
//                             <div className='p-3 bg-body'>
//                               <h6 className='mb-3'>Payment Details</h6>
//                               <Table bordered size='sm' className='mb-0'>
//                                 <thead>
//                                   <tr>
//                                     <th>Payment #</th>
//                                     <th>Invoice #</th>
//                                     <th>Date</th>
//                                     <th>Amount</th>
//                                   </tr>
//                                 </thead>
//                                 <tbody>
//                                   {supplier.payments.map((payment, idx) => (
//                                     <tr key={` {payment.codE_PAYMENTS}- {idx}`}>
//                                       <td>{payment.codE_PAYMENTS}</td>
//                                       <td>{payment.invoiceNumber}</td>
//                                       <td>{formatDate(payment.paymenT_DATE)}</td>
//                                       <td>{formatCurrency(payment.amounT_PAYMENTS)}</td>
//                                     </tr>
//                                   ))}
//                                 </tbody>
//                               </Table>
//                             </div>
//                           </Collapse>
//                         </td>
//                       </tr>
//                     </React.Fragment>
//                   ))}
//                 </tbody>
//               </Table>
//             </div>
//           ) : (
//             <div className='text-center py-5'>
//               <p>No data available. Set your filters and click "Load Report" to generate.</p>
//             </div>
//           )}
//         </CardBody>

//         {data.length > 0 && (
//           <CardFooter className='text-muted'>Report generated on {new Date().toLocaleString()}</CardFooter>
//         )}
//       </Card>
//     </div>
//   );
// };

// export default SupplierPaymentsReport;


import { ntxAPI } from '@API/axiosNeatex';
import { Card, CardBody, CardFooter } from '@components/card/card';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import type { APIResponse } from '@store/Shared/shared';
import { TreeSelect } from 'antd';
import React, { useState } from 'react';
import { Table, Spinner, Form, Row, Col, Button, Alert, CardHeader, Collapse } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ChevronDown, ChevronUp } from 'lucide-react';

// Define types for our data
interface Payment {
  invoiceNumber: string;
  codE_PAYMENTS: string;
  paymenT_DATE: string;
  amounT_PAYMENTS: number;
}

interface SupplierPayment {
  supplierId: string;
  supplierName: string;
  supplierName2: string | null;
  paymentMethod: string;
  totalPayments: number;
  payments: Payment[];
}

const SupplierPaymentsReport: React.FC = () => {
  const { treeSuppliersData } = useGetSuppliersList();
  const [data, setData] = useState<SupplierPayment[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});

  // Filter states
  const [selectedSupplier, setSelectedSupplier] = useState<any>(''); // مثل التقرير الأول
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
  const [startDate, endDate] = dateRange;

  // Function to fetch data with filters
  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await ntxAPI.get<APIResponse<SupplierPayment[]>>('Reports/GetSupplierPaymentsReport', {
        params: { SupplierId: selectedSupplier, StartDate: startDate, EndDate: endDate }
      });

      if (data.succeeded === true) {
        setData(data.data);
      } else {
        setError(data instanceof Error ? data.message : 'حدث خطأ غير معروف');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'حدث خطأ غير معروف');
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = () => {
    setSelectedSupplier('all');
    setDateRange([null, null]);
  };

  const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat('en-US').format(amount);
  };

  const formatDate = (dateString: string): string => {
    return new Date(dateString).toLocaleDateString('en-US');
  };

  // Toggle row expansion
  const toggleRow = (supplierId: string) => {
    setExpandedRows(prev => ({
      ...prev,
      [supplierId]: !prev[supplierId]
    }));
  };

  return (
    <div className=' '>
      <Card className='border-0'>
        <CardBody>
          {error && (
            <Alert variant='danger' className='mb-4'>
              خطأ في تحميل البيانات: {error}
            </Alert>
          )}

          {/* Filters Section */}
          <Card className='mb-4'>
            <CardHeader className='d-flex justify-content-between align-items-center'>
              <div className='mb-0'>الفلاتر</div>
              {data.length > 0 && (
                <div>
                  <span className='me-2'>الإجمالي: {data.length} مورد</span>
                </div>
              )}
            </CardHeader>

            <CardBody>
              <Form>
                <Row className='g-3'>
                  <Col md={4}>
                    <Form.Group controlId='supplierFilter'>
                      <Form.Label>المورد</Form.Label>

                      <TreeSelect
                        showSearch
                        className='w-100'
                        treeLine
                        allowClear
                        treeDefaultExpandAll={false}
                        value={selectedSupplier}
                        onChange={(option: any) => {
                          setSelectedSupplier(option === null ? null : option);
                        }}
                        treeData={treeSuppliersData}
                        treeNodeFilterProp='title'
                        placeholder='اختر المورد'
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group controlId='dateRangeFilter'>
                      <Form.Label>الفترة</Form.Label>
                      <DatePicker
                        allowSameDay
                        selectsRange={true}
                        startDate={startDate}
                        endDate={endDate}
                        onChange={update => setDateRange(update)}
                        className='form-control text-center'
                        placeholderText='اختر الفترة'
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} className='text-end'>
                    <Button variant='secondary' onClick={resetFilters} className='me-2'>
                      تصفير الفلاتر
                    </Button>

                    <Button variant='primary' onClick={fetchData} disabled={loading}>
                      {loading ? (
                        <>
                          <Spinner
                            as='span'
                            animation='border'
                            size='sm'
                            role='status'
                            aria-hidden='true'
                            className='me-2'
                          />
                          جاري التحميل...
                        </>
                      ) : (
                        'تحميل البيانات'
                      )}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>

          {/* Results Section */}
          {loading ? (
            <div className='text-center my-5'>
              <Spinner animation='border' role='status'>
                <span className='visually-hidden'>جاري التحميل...</span>
              </Spinner>
              <p className='mt-2'>جاري تحميل بيانات التقرير...</p>
            </div>
          ) : data.length > 0 ? (
            <div className='table-responsive'>
              <Table striped bordered hover className='mb-0'>
                <thead>
                  <tr>
                    <th style={{ width: '30px' }}></th>
                    <th>المورد</th>
                    <th>طريقة الدفع</th>
                    <th>إجمالي المدفوعات</th>
                    <th>عدد الدفعات</th>
                  </tr>
                </thead>

                <tbody>
                  {data.map(supplier => (
                    <React.Fragment key={supplier.supplierId}>
                      <tr onClick={() => toggleRow(supplier.supplierId)} style={{ cursor: 'pointer' }}>
                        <td>{expandedRows[supplier.supplierId] ? <ChevronUp /> : <ChevronDown />}</td>

                        <td>
                          <div>{supplier.supplierName}</div>
                          {supplier.supplierName2 && <div className='text-muted small'>{supplier.supplierName2}</div>}
                        </td>

                        <td>{supplier.paymentMethod}</td>
                        <td>{formatCurrency(supplier.totalPayments)}</td>
                        <td>{supplier.payments.length}</td>
                      </tr>

                      <tr>
                        <td colSpan={5} className='p-0 border-top-0'>
                          <Collapse in={!!expandedRows[supplier.supplierId]}>
                            <div className='p-3 bg-body'>
                              <h6 className='mb-3'>تفاصيل المدفوعات</h6>

                              <Table bordered size='sm' className='mb-0'>
                                <thead>
                                  <tr>
                                    <th>رقم الدفعة</th>
                                    <th>رقم الفاتورة</th>
                                    <th>التاريخ</th>
                                    <th>المبلغ</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {supplier.payments.map((payment, idx) => (
                                    <tr key={`${payment.codE_PAYMENTS}-${idx}`}>
                                      <td>{payment.codE_PAYMENTS}</td>
                                      <td>{payment.invoiceNumber}</td>
                                      <td>{formatDate(payment.paymenT_DATE)}</td>
                                      <td>{formatCurrency(payment.amounT_PAYMENTS)}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                          </Collapse>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className='text-center py-5'>
              <p>لا توجد بيانات. اختر الفلاتر ثم اضغط "تحميل البيانات" لعرض التقرير.</p>
            </div>
          )}
        </CardBody>

        {data.length > 0 && (
          <CardFooter className='text-muted'>تم إنشاء التقرير بتاريخ {new Date().toLocaleString('en-US')}</CardFooter>
        )}
      </Card>
    </div>
  );
};

export default SupplierPaymentsReport;